// TotalInventoryNearExpiry Mutations

export const updateTotalInventoryNearExpiryList = (state, payload) => {
  state.totalInventoryNearExpiryList = payload
}

export const fetchTotalInventoryNearExpiryCount = (state, payload) => {
  state.totalInventoryNearExpiryCount = payload
}
